import React, { useEffect, useState } from "react";
import Navbar from "../../common/Navbar";
import Footer from "../../common/Footer";
import * as Constants from "../../../Constants/index";
import axios from "axios";
import swal from "sweetalert";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import { useFormik } from "formik";
import ResponsivePagination from "react-responsive-pagination";
import Oval from "../loader/CircleLoade";
import { Link } from "react-router-dom";

export default function EnrollmentReport() {
  const navigate = useNavigate();
  const userType = localStorage.getItem("user_type");
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(10);
  const [filterData, setFilterData] = useState({});
  const [downloadLoading, setDownloadLoading] = useState(false);

  useEffect(() => {
    getReportData(
      {
        mobile: "",
        status: "",
        startDate: "",
        endDate: "",
      },
      1
    );
  }, []);

  const searchFormik = useFormik({
    initialValues: {
      mobile: "",
      status: "",
      startDate: "",
      endDate: "",
    },
    validate: (data) => {
 let errors = {};
      
      // Make startDate and endDate mandatory
      // if (!data.startDate) {
      //   errors.startDate = "Start date is required";
      // }
      
      // if (!data.endDate) {
      //   errors.endDate = "End date is required";
      // }

     if (data.startDate && !data.endDate) {
      errors.endDate = "End date is required when start date is selected";
    }
      
      if (data.mobile) {
        if (data.mobile.length < 10) {
          errors.mobile = "Mobile must be in 10 digits.";
        }
      }
      
      if (data.startDate && data.endDate && data.startDate > data.endDate) {
        errors.endDate = "End date should be greater than start date";
      }

        // ✅ Date Range max 30 days
  // if (data.startDate && data.endDate) {
  //   const diffDays = moment(data.endDate).diff(moment(data.startDate), "days");
  //   if (diffDays > 30) {
  //     errors.endDate = "Date range cannot be more than 30 days";
  //   }
  // }
      
      return errors;
    },
    onSubmit: (data) => {
      setCurrentPage(1);
      getReportData(data, 1);
      setFilterData(data);
    },
  });
  const isSearchFormFieldValid = (name) =>
    !!(searchFormik.touched[name] && searchFormik.errors[name]);
  const getSearchFormErrorMessage = (name) => {
    return (
      isSearchFormFieldValid(name) && (
        <small className="report-error-field">
          {searchFormik.errors[name]}
        </small>
      )
    );
  };

const getReportData = async (data, pageNum) => {
  setLoading(true);
  if (!token) {
    navigate("/");
  } else {
    const searchMobile =
      data?.mobile !== undefined && data?.mobile !== ""
        ? `&mobile=${data?.mobile}`
        : "";

    const searchStatus =
      data?.status !== undefined && data?.status !== ""
        ? `&status=${data?.status}`
        : "";

    let stDate = "";
    let endDate = "";

    // ✅ Only add if both dates are provided
    if (data?.startDate && data?.endDate) {
      const momentObj1 = moment(data.startDate);
      const momentObj2 = moment(data.endDate);

      const startFormattedDate = momentObj1.format("YYYY-MM-DD HH:mm:ss");
      const endFormattedDate = momentObj2.format("YYYY-MM-DD 23:59:59");

      stDate = `&start=${startFormattedDate}`;
      endDate = `&end=${endFormattedDate}`;
    }

    await axios
      .get(
        Constants.baseUrl +
          `reports/users/list?userType=MEMBER${searchMobile}${searchStatus}${stDate}${endDate}&sortBy=createDateTime&sortAsc=false&limit=${limit}&page=${pageNum}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": localStorage.getItem("langauge"),
            appVersion: Constants.av,
            platform: Constants.pt,
            company: Constants.company,
            program: Constants.program,
          },
        }
      )
      .then((res) => {
        const dt = res.data;
        if (dt.result === "success") {
          setReportData(dt?.output?.results);
          setTotalPages(dt?.output?.totalPages);
          setLoading(false);
        }
        if (dt.result === "error" || dt.result === "dialog") {
          setReportData(null);
          setTotalPages(0);
          setLoading(false);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  }
};


  const download = (data) => {
    setLoading(true);
    setDownloadLoading(true);
    try {
      const searchMobile = data.mobile === "" ? "" : `&mobile=${data.mobile}`;
      const searchStatus = data.status === "" ? "" : `&status=${data.status}`;
      let stDate;
      let endDate;

      var momentObj1 = moment(data.startDate);
      var momentObj2 = moment(data.endDate);
      if (data.startDate && data.endDate) {
        var startFormattedDate = momentObj1.format("YYYY-MM-DD HH:mm:ss");
        var startFormattedDate4 = momentObj2.format("YYYY-MM-DD 23:59:59");
        stDate = `&start=${startFormattedDate}`;
        endDate = `&end=${startFormattedDate4}`;
      } else {
        stDate = "";
        endDate = "";
      }

      axios
        .get(
          Constants.baseUrl +
            `reports/download/userreport?userType=MEMBER${searchMobile}${searchStatus}${stDate}${endDate}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Accept-Language": localStorage.getItem("langauge"),
              appVersion: Constants.av,
              platform: Constants.pt,
              company: Constants.company,
              program: Constants.program,
            },
            responseType: "blob", // Set the responseType to 'blob'
          }
        )
        .then((res) => {
          if (res.status === 200) {
            setLoading(false);
            const fileData = new Blob([res.data], { type: "text/csv" });
            saveAs(fileData, "enrollmentReport.csv");
            setDownloadLoading(false);
          } else {
            swal({
              text: res.data.msg,
              // icon: 'error',
              timer: 2000,
              buttons: false,
            });
            setDownloadLoading(false);
          }
        });
    } catch (error) {
      console.log(error);
      setDownloadLoading(false);
    }
  };

  const areAllValuesBlank = () => {
    const { mobile, status, startDate, endDate } = searchFormik.values;
    return !mobile && !status && !startDate && !endDate;
  };
  return (
    <>
      {loading ? <Oval /> : null}
      <Navbar />
      <section class="page-content--bge55">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <h3 class="head1">Enrollment Report</h3>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <form onSubmit={searchFormik.handleSubmit}>
                <div class="row">
                  <div class="col-lg-8 col-md-12 col-sm-12 col-xs-12">
                    <div class="row">
                      <div class="col-md-3 col-sm-12 col-xs-12">
                        <div class="form-group">
                          <input
                            class="form-control reset"
                            type="text"
                            placeholder="Mobile No."
                            id="mobile"
                            value={searchFormik.values.mobile}
                            onChange={(e) => {
                              const numericValue = e.target.value
                                .replace(/\D/g, "")
                                .slice(0, 10);
                              searchFormik.handleChange({
                                target: {
                                  name: "mobile",
                                  value: numericValue,
                                },
                              });
                            }}
                          />
                          {getSearchFormErrorMessage("mobile")}
                        </div>
                      </div>
                        <div className="col-md-3 col-sm-12 col-xs-12">
                        <DatePicker
                          id="startDate"
                          selected={searchFormik.values.startDate}
                          onChange={(date) =>
                            searchFormik.setFieldValue("startDate", date)
                          }
                          dateFormat="dd-MM-yyyy"
                          className="form-control"
                          showYearDropdown
                          showMonthDropdown
                          autoComplete="off"
                          scrollableYearDropdown
                          maxDate={new Date()}
                          onKeyDown={(e) => e.preventDefault()}
                          onFocus={(e) => e.target.blur()}
                          onClick={(e) => e.preventDefault()}
                          placeholderText="From date *"
                          // required
                        />
                        {getSearchFormErrorMessage("startDate")}
                      </div>
                      <div className="col-md-3 col-sm-12 col-xs-12">
                        <DatePicker
                          id="endDate"
                          selected={searchFormik.values.endDate}
                          onChange={(date) => searchFormik.setFieldValue("endDate", date)}
                          dateFormat="dd-MM-yyyy"
                          className="form-control"
                          showYearDropdown
                          showMonthDropdown
                          autoComplete="off"
                          scrollableYearDropdown
                          minDate={searchFormik.values.startDate || null} // end date start से छोटी न हो
                          maxDate={
                            searchFormik.values.startDate
                              ? moment(searchFormik.values.startDate).add(30, "days").toDate()
                              : new Date()
                          }
                          onKeyDown={(e) => e.preventDefault()}
                          onFocus={(e) => e.target.blur()}
                          onClick={(e) => e.preventDefault()}
                          placeholderText="To date *"
                          // required
                        />
                        {/* <DatePicker
                          id="endDate"
                          selected={searchFormik.values.endDate}
                          onChange={(date) =>
                            searchFormik.setFieldValue("endDate", date)
                          }
                          dateFormat="dd-MM-yyyy"
                          className="form-control"
                          showYearDropdown
                          showMonthDropdown
                          autoComplete="off"
                          scrollableYearDropdown
                          maxDate={new Date()}
                          onKeyDown={(e) => e.preventDefault()}
                          onFocus={(e) => e.target.blur()}
                          onClick={(e) => e.preventDefault()}
                          placeholderText="To date *"
                          required
                        /> */}
                        {getSearchFormErrorMessage("endDate")}
                      </div>
                      <div className="col-md-3 col-sm-12 col-xs-12">
                        <select
                          className="form-control"
                          id="status"
                          value={searchFormik.values.status}
                          onChange={searchFormik.handleChange}
                        >
                          <option value="">Select Status</option>
                          <option value="APPROVED">Approved</option>
                          <option value="REJECT">Rejected</option>
                          <option value="Verified">Pending for approval</option>
                          <option value="NEW">New Plumber</option>
                        </select>
                        {getSearchFormErrorMessage("status")}
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                    <div class="d-flex justify-content-between">
                      <button
                        type="submit"
                        class="btn btn-primary report-submit-button"
                        //disabled={areAllValuesBlank()}
                      >
                        Search
                      </button>

                      <button
                        type="button"
                        className="btn btn-primary report-submit-button"
                        onClick={() => {
                          setFilterData({});
                          setCurrentPage(1);
                          searchFormik.resetForm();
                          getReportData(
                            {
                              mobile: "",
                              status: "",
                              startDate: "",
                              endDate: "",
                            },
                            1
                          );
                        }}
                      >
                        Reset
                      </button>

                      {reportData === null ? (
                        ""
                      ) : (
                        <Link
                          to="#"
                          class={`btn btn-primary report-submit-button mx-5 ${
                            downloadLoading ? "btn-opacity" : ""
                          }`}
                          onClick={() => download(searchFormik.values)}
                        >
                          {downloadLoading ? (
                            <span>
                              {" "}
                              <i class="fa fa-spinner fa-spin"></i>Export
                            </span>
                          ) : (
                            " Export"
                          )}
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
              </form>
              <div class="row mt-20">
                <div class="col-md-12">
                  <div class="table-responsive table--no-card">
                    <table class="table table-borderless table-striped table-earning">
                      <thead>
                        <tr>
                          <th>S.No.</th>
                          <th>userUniqueid</th>
                          <th>plumberName</th>
                          <th>plumberMobile</th>
                          <th>userBranch</th>
                          <th>userZone</th>
                          <th>plumberEmail</th>
                          <th>fsMobile</th>
                          <th>fsCode</th>
                          <th>fsName</th>
                          {/* <th>fsZone</th>
                          <th>fsbranch</th> */}
                          <th>memberProfile</th>
                          <th>activeStatus</th>
                          <th>userWorkAddress1</th>
                          <th>userWorkCity</th>
                          <th>userWorkDistrict</th>
                          <th>PINCode</th>
                          <th>userWorkState</th>
                          <th>registrationDate</th>
                          <th>registerFrom</th>
                          <th>userStatus</th>
                          <th>approvalRejectedReason</th>
                          <th>adminApprovalRejectedDate</th>
                          <th>verificationApprovalRejectedDate</th>
                          <th>totalEarnedPoints</th>
                          <th>totalMonthlyBonus</th>
                          <th>totalRedeemedPoints</th>
                          <th>balancePoints</th>
                          <th>HoldPoints</th>
                          <th>quaterlyBonus</th>
                          <th>Bonus</th>
                          <th>tdsPoints</th>
                          <th>basePoints</th>
                          <th>FirstScanDate</th>
                          <th>aadharNumber</th>
                          <th>aadharMobile</th>
                          <th>aadharFrontUrl</th>
                          <th>aadharBackUrl</th>
                          <th>panNumber</th>
                          <th>panFrontUrl</th>
                          <th>gstNumber</th>
                          <th>gstImage</th>
                          <th>profilePic</th>
                          <th>blockedstatus</th>
                          <th>blockedReason</th>
                          <th>preferredRetailerId</th>
                          <th>retailerId1</th>
                          <th>retailerId2</th>
                          <th>retailerId3</th>
                          <th>retailerId4</th>
                          <th>noOfEmployees</th>
                          <th>noOfSites</th>
                          <th>kitchenFabricatedPermonth</th>
                          <th>wstTotalPoints</th>
                          <th>wstPoints</th>
                          <th>wstDeductPoints</th>
                          <th>wstQuaterlyBonus</th>
                          <th>wstAllMonthBonus</th>
                          <th>pftTotalPoints</th>
                          <th>pftPoints</th>
                          <th>pftDeductPoints</th>
                          <th>pftQuaterlyBonus</th>
                          <th>pftAllMonthBonus</th>
                          <th>BeatCode</th>
                          <th>BeatPlanName</th>
                          <th>TerritoryCode</th>
                          <th>TerritoryName</th>
                          <th>TldgMobile</th>
                          <th>tldgCode</th>
                          <th>tldgName</th>
                          <th>promoterMobile</th>
                          <th>promoterCode</th>
                          <th>promoterName</th>
                        </tr>
                      </thead>
                      {reportData === null ? (
                        <tbody>
                          <tr>
                            <td
                              colSpan="45"
                              style={{ textAlign: "center", fontSize: "16px" }}
                            >
                              No record found!
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        <tbody>
                          {reportData &&
                            reportData.map((item, index) => {
                              const serialNumber =
                                (currentPage - 1) * limit + index + 1;
                              return (
                                <tr key={index}>
                                  <td>{serialNumber}</td>
                                  <td>{item[0]}</td> {/* userUniqueid */}
                                  <td>{item[1] ? item[1] : " "}</td> {/* plumberName */}
                                  <td>{item[2] ? item[2] : " "}</td> {/* plumberMobile */}
                                  <td>{item[3] ? item[3] : " "}</td> {/* userBranch */}
                                  <td>{item[4] ? item[4] : " "}</td> {/* userZone */}
                                  <td>{item[5] ? item[5] : " "}</td> {/* plumberEmail */}
                                  <td>{item[6] ? item[6] : " "}</td> {/* fsMobile */}
                                  <td>{item[7] ? item[7] : " "}</td> {/* fsCode */}
                                  <td>{item[8] ? item[8] : " "}</td> {/* fsName */}
                                  <td>{item[9] ? item[9] : " "}</td> {/* memberProfile */}
                                  <td>{item[10] ? item[10] : " "}</td> {/* activeStatus */}
                                  <td>{item[11] ? item[11] : " "}</td> {/* userWorkAddress1 */}
                                  <td>{item[12]}</td> {/* userWorkCity */}
                                  <td>{item[13]}</td> {/* userWorkDistrict */}
                                  <td>{item[14]}</td> {/* PINCode */}
                                  <td>{item[15]}</td> {/* userWorkState */}
                                  <td>{item[16]}</td> {/* registrationDate */}
                                  <td>{item[17]}</td> {/* registerFrom */}
                                  <td>{item[18]}</td> {/* userStatus */}
                                  <td>{item[19]}</td>{" "}
                                  {/* approvalRejectedReason */}
                                  <td>{item[20]}</td>{" "}
                                  {/* adminApprovalRejectedDate */}
                                  <td>{item[21]}</td>{" "}
                                  {/* verificationApprovalRejectedDate */}
                                  <td>{item[22]}</td> {/* totalEarnedPoints */}
                                  <td>{item[23]}</td> {/* totalMonthlyBonus */}
                                  <td>{item[24]}</td>{" "}
                                  {/* totalRedeemedPoints */}
                                  <td>{item[25]}</td> {/* balancePoints */}
                                  <td>{item[26]}</td> {/* HoldPoints */}
                                  <td>{item[27]}</td> {/* quaterlyBonus */}
                                  <td>{item[28]}</td> {/* Bonus */}
                                  <td>{item[29]}</td> {/* tdsPoints */}
                                  <td>{item[30]}</td> {/* basePoints */}
                                  <td>{item[31]}</td> {/* FirstScanDate */}
                                  <td>{item[32]}</td> {/* aadharNumber */}
                                  <td>{item[33]}</td> {/* aadharMobile */}
                                  {/* Aadhaar Front */}
                                  <td>
                                    {item[34] ? (
                                      <Link
                                        to={item[34]}
                                        target="_blank"
                                        className="select"
                                      >
                                        View
                                      </Link>
                                    ) : (
                                      "N/A"
                                    )}
                                  </td>
                                  {/* Aadhaar Back */}
                                  <td>
                                    {item[35] ? (
                                      <Link
                                        to={item[35]}
                                        target="_blank"
                                        className="select"
                                      >
                                        View
                                      </Link>
                                    ) : (
                                      "N/A"
                                    )}
                                  </td>
                                  <td>{item[36]}</td> {/* panNumber */}
                                  {/* PAN Front */}
                                  <td>
                                    {item[37] ? (
                                      <Link
                                        to={item[37]}
                                        target="_blank"
                                        className="select"
                                      >
                                        View
                                      </Link>
                                    ) : (
                                      "N/A"
                                    )}
                                  </td>
                                  <td>{item[38]}</td> {/* gstNumber */}
                                  {/* GST Image */}
                                  <td>
                                    {item[39] ? (
                                      <Link
                                        to={item[39]}
                                        target="_blank"
                                        className="select"
                                      >
                                        View
                                      </Link>
                                    ) : (
                                      "N/A"
                                    )}
                                  </td>
                                  {/* Profile Pic */}
                                  <td>
                                    {item[40] ? (
                                      <Link
                                        to={item[40]}
                                        target="_blank"
                                        className="select"
                                      >
                                        View
                                      </Link>
                                    ) : (
                                      "N/A"
                                    )}
                                  </td>
                                  <td>{item[41]}</td> {/* blockedstatus */}
                                  <td>{item[42]}</td>{" "}
                                  <td>{item[43]}</td> {/* retailerId1 */}
                                  <td>{item[44]}</td> {/* retailerId2 */}
                                  <td>{item[45]}</td> {/* retailerId3 */}
                                  <td>{item[46]}</td> {/* retailerId4 */}
                                  <td>{item[47]}</td> {/* noOfEmployees */}
                                  <td>{item[48]}</td> {/* noOfSites */}
                                  <td>{item[49]}</td>{" "}
                                  <td>{item[50]}</td> {/* wstTotalPoints */}
                                  <td>{item[51]}</td> {/* wstPoints */}
                                  <td>{item[52]}</td> {/* wstDeductPoints */}
                                  <td>{item[53]}</td> {/* wstQuaterlyBonus */}
                                  <td>{item[54]}</td> {/* wstAllMonthBonus */}
                                  <td>{item[55]}</td> {/* pftTotalPoints */}
                                  <td>{item[56]}</td> {/* pftPoints */}
                                  <td>{item[57]}</td> {/* pftDeductPoints */}
                                  <td>{item[58]}</td> {/* pftQuaterlyBonus */}
                                  <td>{item[59]}</td> {/* pftAllMonthBonus */}
                                  <td>{item[60]}</td> {/* BeatCode */}
                                  <td>{item[61]}</td> {/* BeatPlanName */}
                                  <td>{item[62]}</td> {/* TerritoryCode */}
                                  <td>{item[63]}</td> {/* TerritoryName */}
                                  <td>{item[64]}</td> 
                                  <td>{item[65]}</td> 
                                  <td>{item[66]}</td> 
                                  <td>{item[67]}</td> 
                                  <td>{item[68]}</td> 
                                  <td>{item[69]}</td>
                                  <td>{item[70]}</td> 
                                </tr>
                              );
                            })}
                        </tbody>
                      )}
                    </table>
                    {totalPages > 1 && (
                      <ResponsivePagination
                        current={currentPage}
                        total={totalPages}
                        onPageChange={(page) => {
                          setCurrentPage(page);
                          getReportData(filterData, page);
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
